import { useState } from 'react';
import { Languages, Loader2, Sparkles } from 'lucide-react';
import { toast } from 'sonner';
import { streamAiText } from '../../utils/ai';
import { inputCls } from '../../utils/operations';

export const AdminContent = () => {
  const [prompt, setPrompt] = useState('');
  const [output, setOutput] = useState('');
  const [target, setTarget] = useState('EN');
  const [busy, setBusy] = useState('');
  const [error, setError] = useState('');

  const run = async (mode) => {
    if (!prompt.trim()) return toast.error('Escreva um briefing ou texto primeiro');
    setBusy(mode);
    setOutput('');
    setError('');
    try {
      await streamAiText({ prompt, mode, targetLang: target, onDelta: (text) => setOutput(text) });
      toast.success(mode === 'translate' ? 'Tradução concluída' : 'Conteúdo gerado');
    } catch (err) {
      setError(String(err.message));
      toast.error('AI indisponível', { description: String(err.message) });
    } finally {
      setBusy('');
    }
  };

  return (
    <div className="grid gap-6 lg:grid-cols-2" data-testid="admin-ai-content">
      <div className="rounded-xl border border-eco-ink/10 bg-white p-6">
        <h2 className="font-serif text-xl font-semibold text-eco-ink">Briefing / texto fonte</h2>
        <p className="mt-1 text-sm text-eco-ink/55">A IA sugere texto, mas nunca inventa preço, review, disponibilidade ou certificação. Reveja antes de publicar.</p>
        <textarea data-testid="ai-prompt" rows={12} value={prompt} onChange={(e) => setPrompt(e.target.value)} className={`${inputCls} mt-5`} placeholder="Ex: Criar descrição honesta para um passeio guiado…" />
        <div className="mt-4 flex flex-wrap gap-3">
          <button data-testid="ai-generate" onClick={() => run('generate')} disabled={Boolean(busy)} className="eco-btn-primary disabled:opacity-60">
            {busy === 'generate' ? <Loader2 size={15} className="animate-spin" /> : <Sparkles size={15} />} Gerar
          </button>
          <select data-testid="ai-target-language" value={target} onChange={(e) => setTarget(e.target.value)} className="rounded-full border border-eco-ink/15 bg-white px-4 py-2 text-sm">
            {['PT', 'EN', 'DE', 'FR'].map((l) => <option key={l}>{l}</option>)}
          </select>
          <button data-testid="ai-translate" onClick={() => run('translate')} disabled={Boolean(busy)} className="inline-flex min-h-11 items-center gap-2 rounded-[10px] border border-eco-gold/40 px-5 text-sm font-semibold text-eco-gold transition-colors hover:bg-eco-gold/10 disabled:opacity-60">
            {busy === 'translate' ? <Loader2 size={15} className="animate-spin" /> : <Languages size={15} />} Traduzir
          </button>
        </div>
      </div>
      <div className="rounded-xl border border-eco-ink/10 bg-white p-6">
        <h2 className="font-serif text-xl font-semibold text-eco-ink">Resultado para revisão</h2>
        <div data-testid="ai-output" className="mt-5 min-h-72 whitespace-pre-wrap rounded-2xl bg-eco-cream p-5 text-sm leading-relaxed text-eco-ink/75">
          {output || 'O texto gerado aparece aqui. Nada é publicado automaticamente.'}
        </div>
        {error && <p data-testid="ai-error" className="mt-3 rounded-xl bg-red-50 px-4 py-2.5 text-sm font-medium text-red-600">{error}</p>}
      </div>
    </div>
  );
};
